<template>
    <div class="recommendMain">
        <p class="current">当前位置：<span>推荐</span></p>
        <div class="recom-box">
            <div class="menu-recom">
                <el-menu
                    ref="menu"
                    class="el-menu-vertical-demo"
                    default-active="1"
                    background-color="#fff"
                    text-color="#000"
                    active-text-color="#00a8a8">
                        <el-menu-item index="1"  @click="handleMenu(id='')">全部</el-menu-item>
                        <el-menu-item v-for="item,index in menuList" :key="item.cate_id" :index="2+index.toString()" @click="handleMenu(item.cate_id)">{{ item.cate_name }}</el-menu-item>
                     
                
                </el-menu>
            </div>
            <div class="artcleRecom-right">
                <div class="search-page">
                    <Search style="margin-bottom: 40px;width: 600px;" @inputKey="inputKey"></Search>
                    <el-button type="primary" round @click="addJoin()" >+供应商入驻</el-button>
                </div>

                <div style="background: #fff;padding: 10px 10px;margin-top: 10px;">
                    <div v-for="item in listTrain" :key="item.id"  @click="getRecommendInfo(item)">
                        <div class="contentRecom-div" >
                            <div class="divImage" v-show="item.firstFile.FileUrl" :style="'background-image: url('+item.firstFile.FileUrl+');width: 130px;height: 70px'"></div>
                            <div class="divImage" v-show="!item.firstFile.FileUrl" style="background-image: url(./../assets/logo666.png)"></div>
                           
                            <div class="recomInfo">
                                <p class="recom-pname">{{ item.name }}</p>
                                <p class="recom-p">{{ item.description }}</p>
                            </div>
                        
                        </div>
                        <el-divider   ></el-divider>
                    </div>
                    
                    
                
                </div>
                <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
                       
            </div>
          
        </div>
    </div>
</template>

<script>
import Search from "../search/index.vue"
export default({
    data(){
        return{
            menuList: [],
            listTrain: [],
            total: 0,
            hideOnSinglePage: true,
            keywords: '',
            cate_id: '',
            widthNew: false
        }
    },
    components: {
        Search,
    },
    watch: {
    
      
    },
    methods:{
        addJoin(){
            this.$router.push({
                path: '/join'
            })
        },
        getmMnuList(data){
            this.$store.dispatch('video/listcate',data)
                .then(res => {
                    if(res.ok){
                        this.menuList = res.data
                    }
                })
        },
        getListTrain(data){
            this.$store.dispatch('menu/listcompany',data)
                .then(res =>{
                    if(res.ok){
                        this.listTrain = res.data.items
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                })
        },
        handleMenu(id){
            console.log(id);
            this.cate_id = id
            let listTrain = {
                pageNum: 1,
                pageSize: 20,
                cates: id,
                keywords: this.keywords
            }
            this.getListTrain(listTrain)
        },
        inputKey(val){
            this.keywords = val
            let listTrain = {
                pageNum: 1,
                pageSize: 20,
                cates: this.cate_id,
                keywords: val
            }
            this.getListTrain(listTrain)
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let listTrain = {
                pageNum: 1,
                pageSize: 20,
                cates: this.cate_id,
                keywords: this.keywords
            }
            this.getListTrain(listTrain)
        },
        getRecommendInfo(item){
            console.log(item);
            this.$router.push({
                path: '/companyDetail',
                query:{
                    key: item.id,
                    currentName: '公司详情'
                }
            })
        },
    },
    mounted(){
        
    },
    
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let data = {
            parent_cate_value: 'company'
        }
        this.getmMnuList(data)
        
        let listTrain = {
            pageNum: 1,
            pageSize: 10,
            cates: '',
            keywords: ''
        }
        this.getListTrain(listTrain)
      
    }
})
</script>

<style scoped lang="scss">
.recommendMain{
    width: 1200px;
    margin: 45px auto;
    .current{
        margin-top: -35px;
        position: relative;
        font-size: 17px;
        color: #333;
        span{
            font-size: 16px;
            cursor: pointer;
            color: #666666;
        }
    }
    .recom-box{
        width: 1200px;
        margin: 15px auto;
        display: flex;
        justify-content: space-between;
        .menu-recom{
            width: 210px;
            align-self: flex-start;
            text-align: center;
            background: #fff;
            padding: 10px 10px;
            .el-menu{border:0;
                .el-menu-item {
                    background-color: rgba(0, 0, 0, 0.1);
                    font-size: 18px;
                    margin-top:1px;
                }
                .el-menu-item.is-active {
                    /* background-color: rgba(0,168,168,.1) !important; */
                    margin-top:1px;
                }
            }
                
        }
        .artcleRecom-right{
            width: 930px;
            padding: 0 10px;
            background-color: #fff;
            .contentRecom-div{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;
                .divImage{
                    width: 130px; height: 70px;
                    margin-right: 10px;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: center;
                }
                .recomInfo{
                    width: 770px;
                    .recom-pname{
                        font-size: 18px;
                        margin-bottom: 8px;
                    }
                    .recom-p{
                        font-size: 16px;
                        color: #666666;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                }
            }
            .search-page{
                padding: 10px 0 10px 5px;
                height: 45px;
              
            }
            .pagination{
                margin-top: 40px;
                text-align: right;
            }
        }
    }


}




.el-divider{
  background-color: #f2f2f2;
}
</style>